import { render, staticRenderFns } from "./FactoryDetailPage.vue?vue&type=template&id=d5d4ce3a&scoped=true"
import script from "./FactoryDetailPage.vue?vue&type=script&lang=ts"
export * from "./FactoryDetailPage.vue?vue&type=script&lang=ts"
import style0 from "./FactoryDetailPage.vue?vue&type=style&index=0&id=d5d4ce3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d4ce3a",
  null
  
)

export default component.exports